import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Box, Typography } from '@material-ui/core';

import styles from './styles';

const useStyles = makeStyles(styles);

const DialogDetailsPaymentItem = ({ label, value }) => {
  const classes = useStyles();

  return (
    <Box className={classes.dialogDetailsPaymentItemContainer}>
      <Typography
        component="h6"
        className={classes.dialogDetailsPaymentItemLabel}
      >
        {label}
      </Typography>

      {value && (
        <Typography
          component="p"
          className={classes.dialogDetailsPaymentItemValue}
        >
          {value}
        </Typography>
      )}
    </Box>
  );
};

DialogDetailsPaymentItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};

DialogDetailsPaymentItem.defaultProps = {
  value: null,
};

export default DialogDetailsPaymentItem;
